<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'HeaderOnglet'
});
</script>
<template>
  <ka-container
    code="header-onglet"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text code="onglet-expert">
      <span v-html="t('headerOnglet.ongletExpert.value', `{0} `, [componentInstance.$titreOnglet.value])" />
    </ka-text>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { headerOngletComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c5')
const component = headerOngletComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  titreOnglet?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  titreOnglet: 'Onglet',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:titreOnglet'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: { titreOnglet: true }
})
</script>
